export const REDUCER_ACTIONS = {
    SET_SCHEDULE_EVENTS: 'SET_SCHEDULE_EVENTS',
    ADD_SCHEDULE_EVENT_AVAILABLE_TIMES: 'ADD_SCHEDULE_EVENT_AVAILABLE_TIMES',
    ADD_APPOINTMENTS: 'ADD_APPOINTMENTS',
    SET_CURRENT_APPOINTMENT: 'SET_CURRENT_APPOINTMENT'
};
